import http from "./http";

function getUser() {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/users/current`, {
        headers: {
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function getUsers(params) {
  const apiUsers = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiUsersURL
    : "http://192.168.3.173/social-service/api";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .get(`${apiUsers}`, {
        headers: {
          "ticket-sso": token,
        },
        params: {
          ...params,
          enabled: true,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function getUserConfiguration() {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/users/current/configuration`, {
        headers: {
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res && res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function postUserConfiguration(params) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .post(`${api}/users/current/configuration`, params, {
        headers: {
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function updateUserConfiguration(params) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/users/current/configuration/${params.id}`, params, {
        headers: {
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

export default {
  getUser,
  getUsers,
  getUserConfiguration,
  postUserConfiguration,
  updateUserConfiguration,
};
